"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedScriptDef = typedScriptDef;
exports.canAccessScript = canAccessScript;
/**
 * Helper function to write strongly typed script definitions
 */
function typedScriptDef(def) {
    return def;
}
/**
 * Gate a script on `allowedProjectRoles`, on top of the SCRIPTS endpoint ACL.
 * Unrestricted scripts are open; restricted ones need the role, or SUPER_ADMIN.
 */
function canAccessScript(def, user, acl) {
    if (def.allowedProjectRoles == undefined) {
        return true;
    }
    if ((user === null || user === void 0 ? void 0 : user.role) === 'SUPER_ADMIN') {
        return true;
    }
    const projectRole = acl && 'role' in acl ? acl.role : undefined;
    return projectRole != undefined && def.allowedProjectRoles.includes(projectRole);
}
//# sourceMappingURL=Index.js.map